import { Typography, Box, useTheme, TextField, Divider, Autocomplete, FormControlLabel, Select, MenuItem, FormControl, InputLabel, Button, Grid, Dialog, Tooltip, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { Edit } from "@mui/icons-material";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import useMaterialCategory from "../../hooks/useMaterialCategory";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import DeleteForeverIcon from '@mui/icons-material/HighlightOff';
import useMaterialSubCategory from "../../hooks/useMaterialSubCategory";
const AddPartyType = ({ onClose, handleBackWinderMachineEntry, open }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [selectedSubCategoryNew, setSelectedSubCategoryNew] = useState(null);
    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');

    const [status, setStatus] = useState('Active');
    const [openDialog, setOpenDialog] = useState(false);
    const [btntext, setBtntext] = useState('Add');

    const handleOpen = (row = null) => {
        if (row) {
            setPartyID(row.id)
            setStatus(row.status);
            setSelectedPartyType(row.description)
            setBtntext('Update')
        } else {
            setPartyID(null)
            setStatus('Active')
            setSelectedPartyType('')
            setBtntext('Add')
        }
        setOpenDialog(true);
    };


    const CategoryColumns = [
             {
            field: "actions",
            headerName: "",
            width: 60,
            sortable: false,
            filterable: false,
            renderCell: (params) => (


                <>
                    <Tooltip title="Edit" arrow>
                        <IconButton color="info" onClick={() => handleOpen(params.row)}>
                            <Edit />
                        </IconButton>
                    </Tooltip>


                    {/* <Tooltip title="Delete">
                        <IconButton
                            color="error"

                            onClick={() => handleAddDeleteSubCategory('DELETE', params.row.id)}
                        >
                            <DeleteForeverIcon />
                        </IconButton>
                    </Tooltip> */}


                </>
            )
        },
        {
            field: 'sno',
            headerName: 'S.No',
            width: 80,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
        },

        {
            field: "description",
            headerName: "Party Type",
            width: 170,
            cellClassName: "name-column--cell"

        },

        {
            field: "status",
            headerName: "Status",
            flex: 1,
            cellClassName: "name-column--cell"

        },

   
    ];

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [partyID, setPartyID] = useState(0);
    const [partyType, setPartyType] = useState([]);
    const [selectedPartyType, setSelectedPartyType] = useState(null);

    useEffect(() => {
        if (!isDataLoaded) {
            LoadPartyList();
        }
    }, [isDataLoaded]);

    const LoadPartyList = () => {
        const para = {
            p_companyid: localStorage.getItem('companyid'),
            p_plantid: 1,
            p_mode_str: 'all'
        }
        callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_GET_PARTY_TYPE, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    // Update state with fetched data
                    setPartyType(data);
                }
            })
            .catch(error => {
                // Update state with error message        
                setParentRollSeverityvalue('error');
                setParentRollMessageValue(error.message);
                setParentRollAlertTitleValue('Error');
                setParentRollMsgOpen(true);
                // 

            });
    }



    const handleAddDeleteSubCategory = (mode, id) => {
        setParentRollMsgOpen(false);

        if (mode === 'DELETE') {
            if (window.confirm("Are you sure you want to delete this party type?")) {
                // If user confirms, proceed with deletion
                setSelectedPartyType(null);
            }
            else {
                // If user cancels, exit the function
                return;
            }
        }

        // validation
        let isValid = true;
        let validation_msg = '';

        if (selectedPartyType === '' || selectedPartyType === null || selectedPartyType === undefined) {
            validation_msg += 'Please enter the party type.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_mode_str: mode,  // required for backend to know operation
                p_companyid: parseInt(localStorage.getItem('companyid')),
                p_plantid: 1,
                p_party_type: selectedPartyType || '',  // new sub category name
                p_party_type_id: id || null, // not needed for ADD
                p_status: status
            };

            callApi(API_ENDPOINTS.PURCHASE_MANAGEMENT_CRUD_PARTY_TYPE, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value === 0) {
                            const action = mode === 'ADD' ? 'added' : 'deleted';
                            toast.success(`Party type ${action} successfully.`, { position: toast.POSITION.BOTTOM_CENTER });
                            LoadPartyList();
                        }

                        else if (data[0].result_value === 2) {
                            const action = 'updated';
                            toast.success(`Party type ${action} successfully.`, { position: toast.POSITION.BOTTOM_CENTER });
                            LoadPartyList();
                        }
                        else if (data[0].result_value === 1) {
                            const message = mode === 'ADD'
                                ? 'Party type already exists.'
                                : 'Party type not found.';
                            toast.error(message, { position: toast.POSITION.BOTTOM_CENTER });
                        }
                        else if (data[0].result_value === -1) {
                            toast.error('Invalid Mode Specified.', { position: toast.POSITION.BOTTOM_CENTER });
                        }

                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        } else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };


    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography variant="h5" fontWeight={'bold'} color="secondary">Party Type Master</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >



                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6">Party type <span style={{ color: 'red' }}>*</span></Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField placeholder='Enter the party type' value={selectedPartyType} color="secondary" onChange={(e) => setSelectedPartyType(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>                               </Box>
                            </Box>

                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={4}
                            >
                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    mt={1}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"
                                >
                                    <Typography variant="h6"> Status</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <FormControl fullWidth margin="dense" size='small' color="secondary">

                                        <Select
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                        >
                                            <MenuItem value="Active">Active</MenuItem>
                                            <MenuItem value="InActive">InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>



                            <Box marginTop={6}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button
                                        onClick={() =>
                                            btntext === 'Add'
                                                ? handleAddDeleteSubCategory('ADD', null)
                                                : handleAddDeleteSubCategory('UPDATE', partyID)
                                        }
                                        size="small"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        {btntext}
                                    </Button>

                                    <Button size="small"

                                        variant="contained"
                                        sx={{
                                            marginLeft: "10px",
                                            backgroundColor: '#6C757D',
                                            color: '#fff',
                                            '&:hover': {
                                                backgroundColor: '#6C757D'
                                            }
                                        }}

                                        onClick={() => handleOpen(null)} >
                                        Clear
                                    </Button>
                                </Box>
                            </Box>

                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> Party type list</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" getRowId={(row) => row.id} pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={partyType} columns={CategoryColumns}


                                    />

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>

            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>
                <Button size='small' onClick={onClose} variant="outlined" color="error" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddPartyType;